export { type GraphemeSubtlex, graphemeSubtlexTable } from "#grapheme-subtlex-table";
